module.exports = __webpack_public_path__ + "img/react-ecommerce5.4bb01412.png";